// The site's own addresses on the host the page is served from (Phase 2 white-label).
//
// momsite is ONE build for every vertical's accounts.<domain>, but its .env holds one vertical's full
// addresses (VUE_APP_BASE_URL = https://accounts.circleram.ai/), which sent SchoolNode / Sikh Scholar Hub
// merchants to the CircleRAM domain. A full address in the .env keeps only its path and gets this page's
// origin instead. Relative values (SuperAdmin's /superadmin) and local development addresses are unchanged.

import brand from './brand.service'

function isLocal(hostname) {
  return hostname === 'localhost' || /^[\d.]+$/.test(hostname)
}

// A configured address moved onto this page's host: https://accounts.circleram.ai/support on
// accounts.schoolnode.ai -> https://accounts.schoolnode.ai/support.
export function onThisHost(url) {
  if (!url || !/^https?:\/\//i.test(url) || typeof window === 'undefined') return url
  try {
    const configured = new URL(url)
    if (isLocal(configured.hostname)) return url
    return window.location.origin + configured.pathname + configured.search + configured.hash
  } catch (e) {
    return url
  }
}

// VUE_APP_BASE_URL on this page's host.
export function siteBaseUrl() {
  return onThisHost(process.env.VUE_APP_BASE_URL)
}

// The vertical's public site (https://<its base domain>/, from the platform vertical row); the .env
// value when no vertical is known.
export function businessSiteUrl() {
  const domain = brand.tenantBaseDomain
  return domain ? 'https://' + domain + '/' : process.env.VUE_APP_BUSINESS_URL
}
